import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { IPractitioner } from "lobbie";
import { buildResourcePathForCurrentUser } from "../ResourceBuilder";
import type { RootState } from "../store";

const practitionerApi = createApi({
    reducerPath: "lobbie/account/practitioners",
    baseQuery: fetchBaseQuery({}),
    endpoints: (builder) => ({
        getPractitionersForAccount: builder.query<IPractitioner[], void>({
            queryFn: async (_, api) => {
                const fetchUrl = buildResourcePathForCurrentUser(
                    api.getState() as RootState,
                    "practitioners",
                );
                return await axios.get<IPractitioner[]>(fetchUrl!, { withCredentials: true });
            },
        }),
        getPractitioner: builder.query<IPractitioner, number>({
            queryFn: async (practitionerId, api) => {
                const fetchUrl = buildResourcePathForCurrentUser(
                    api.getState() as RootState,
                    `practitioners/${practitionerId}`,
                );
                return await axios.get<IPractitioner>(fetchUrl!, { withCredentials: true });
            },
        }),
    }),
});

export const {
    useGetPractitionersForAccountQuery,
    useGetPractitionerQuery,
    useLazyGetPractitionersForAccountQuery,
    useLazyGetPractitionerQuery,
} = practitionerApi;

export default practitionerApi;
